import { render } from "./TeacherImport.vue?vue&type=template&id=47d224b3&scoped=true&ts=true"
import script from "./TeacherImport.vue?vue&type=script&lang=ts"
export * from "./TeacherImport.vue?vue&type=script&lang=ts"

import "./TeacherImport.vue?vue&type=style&index=0&id=47d224b3&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47d224b3"]])

export default __exports__